import { useMiscUI } from "../../contexts/MiscUI/MiscUIProvider";
import Portal from "../Portal/Portal";

import styles from "./globalLoadingOverlay.module.css";

export default function GlobalLoadingOverlay() {
  const [state] = useMiscUI();

  if (!state.globalLoading) {
    return null;
  }

  return (
    <Portal path="frontportal">
      <div className={styles.globalLoadingOverlay}>
        <span className="spinner-border" />
      </div>
    </Portal>
  );
}
